export default __webpack_public_path__ + "static/media/rear.a2ddd81f.png";